/*
  babyhyllan — rörelse i mobilen.

  On a computer things answer the pointer (assets/bb-ny-stil.css, Movement):
  a product card's niche lights up and its product lifts, its name is
  underlined, the picture beside Om oss comes a little closer, a promise's
  icon lifts. On a phone nothing is pointed at, so what passes through the
  middle of the screen while scrolling answers in the same way: it gets the
  class bb-fokus while it is in a band across the middle, and the stylesheet
  gives it the pointer's look there.

  Only on touch screens, never for someone who has asked for less motion,
  and only in the page's own content. Cards that arrive later (filters, more
  products) are picked up as they come.
*/

const beroring = window.matchMedia('(hover: none)');
const lugn = window.matchMedia('(prefers-reduced-motion: reduce)');
const VALJARE = ['.product-card', '.resource-list__item', '.bb-bildtext', '.bb-trustrow__item'].join(',');

let iakttagare = null;

function folj(rot) {
  if (rot.nodeType !== 1) return;
  if (rot.matches(VALJARE)) iakttagare.observe(rot);
  rot.querySelectorAll(VALJARE).forEach((el) => iakttagare.observe(el));
}

function starta() {
  if (iakttagare || !beroring.matches || lugn.matches || !('IntersectionObserver' in window)) return;
  iakttagare = new IntersectionObserver(
    (poster) => {
      for (const p of poster) p.target.classList.toggle('bb-fokus', p.isIntersecting);
    },
    // a band across the middle fifth of the screen
    { rootMargin: '-40% 0px -40% 0px' }
  );
  // the page's own content only: cards in the cart drawer or the menu stay still
  const huvud = document.querySelector('main') || document.body;
  folj(huvud);
  new MutationObserver((andringar) => {
    for (const a of andringar) a.addedNodes.forEach(folj);
  }).observe(huvud, { childList: true, subtree: true });
}

starta();
beroring.addEventListener('change', starta);
lugn.addEventListener('change', starta);
